type Scope = 'mine' | 'all';

export function ScopeToggle({
  value,
  onChange,
}: {
  value: Scope;
  onChange: (s: Scope) => void;
}) {
  function btn(scope: Scope, label: string) {
    const active = value === scope;
    return (
      <button
        type="button"
        onClick={() => onChange(scope)}
        className={[
          'h-8 px-3 text-sm rounded-[var(--radius-xs)]',
          active
            ? 'bg-[var(--color-ink)] text-[var(--color-paper)]'
            : 'text-[var(--color-text-muted)] hover:bg-[var(--color-page)]',
        ].join(' ')}
      >
        {label}
      </button>
    );
  }
  return (
    <div className="inline-flex gap-1 border border-[var(--color-border)] rounded-[var(--radius-sm)] p-1">
      {btn('mine', 'Мои')}
      {btn('all', 'Все')}
    </div>
  );
}
